import { createApp } from 'vue';
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { initTelemetry } from './telemetry';
import { promotePendingOrg } from './auth/signedInOrgs';
import './styles/main.scss';

async function bootstrap(): Promise<void> {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 30_000,
      },
    },
  });

  const app = createApp(App);
  app.use(createPinia());
  app.use(router);
  app.use(VueQueryPlugin, { queryClient });
  app.mount('#app');

  // Fire-and-forget: telemetry must never block or break app startup.
  void initTelemetry();

  // A sign-in lands here as a full page load, which is what makes this the
  // once-per-sign-in hook (ADR-0023 Amendment D).
  void promotePendingOrg();
}

void bootstrap();
